<template>
  <div id="app" class="off-canvas-wrapper">
    <div class="off-canvas-wrapper-inner" data-off-canvas-wrapper>
      <div class="off-canvas-content" data-off-canvas-content>
        <header class="header header-light-text" style="background-image:url('static/img/sos-chat-header.jpg')">
          <div class="row collapse">
            <div class="small-6 medium-5 columns">
              <a href="https://www.kirkens-sos.no/" class="header__brand">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 253.4 36.3" class="header__brand__logo"><path fill="#fff" d="M55.4 12.9L43 24V12.9h-3.1v22.6H43v-7.7l4.3-3.8 9.1 11.5h3.8L49.6 21.9l10.1-9zM62.7 12.9h3.1v22.6h-3.1z"/><path d="M73.4 35.5h-3.1V12.9h11.2c4.6 0 7.7 3 7.7 6.7 0 3.5-2.8 6.3-7 6.6l7.2 9.2h-3.7l-7.1-9.2h-5.2v9.3zm7.8-11.9c2.8 0 4.8-1.6 4.8-4s-2-4-4.8-4h-7.8v8h7.8zM95.5 35.5h-3V12.9h3V24L108 12.9h4.2l-10.1 9 10.7 13.6H109L99.9 24l-4.4 3.8zM130.9 22.9v2.7h-12.5v7.1h13.1v2.8h-16.2V12.9h16.2v2.9h-13.1v7.1zM154.4 29.5V12.9h3v23.4l-18.6-17.4v16.6h-3V12.1zM177.4 18.4c-1.6-1.4-4.2-3-7.4-3-4 0-5.6 1.8-5.6 3.6 0 5.5 15.1 1 15.1 10.1 0 4.5-3.6 6.9-9.5 6.9-4.9 0-7.9-1.8-9.5-3.2l1.4-2.5c1.7 1.5 4.6 2.8 8.2 2.8 4.4 0 6.2-1.7 6.2-3.8 0-5.8-15-1.2-15-10.1 0-4 3.3-6.5 8.8-6.5 4.2 0 7.4 2.2 8.6 3.4l-1.3 2.3zM204.7 19.4c-1.7-1.4-4.2-2.8-7.2-2.8-3.1 0-4.4 1.2-4.4 2.6 0 4.4 14.4 0 14.4 9.7 0 4.8-4.1 7.1-10.1 7.1-4.8 0-8.2-1.7-10-3.2l2.1-3.8c1.9 1.6 4.8 2.8 8 2.8 3.7 0 5.1-1.3 5.1-2.8 0-4.6-14.3-.4-14.3-9.7 0-4.4 3.7-6.9 9.2-6.9 4.4 0 7.5 1.9 9.2 3.4l-2 3.6zM232.8 24.2c0 6.5-5.4 11.8-12 11.8s-12-5.3-12-11.8c0-6.5 5.4-11.8 12-11.8s12 5.3 12 11.8m-4.8 0c0-4-3.2-7.3-7.2-7.3s-7.2 3.2-7.2 7.3 3.2 7.3 7.2 7.3 7.2-3.3 7.2-7.3M250.6 19.4c-1.7-1.4-4.2-2.8-7.2-2.8-3.1 0-4.4 1.2-4.4 2.6 0 4.4 14.4 0 14.4 9.7 0 4.8-4.1 7.1-10.1 7.1-4.8 0-8.2-1.7-10-3.2l2.1-3.8c1.9 1.6 4.8 2.8 8 2.8 3.7 0 5.1-1.3 5.1-2.8 0-4.6-14.3-.4-14.3-9.7 0-4.4 3.7-6.9 9.2-6.9 4.4 0 7.5 1.9 9.2 3.4l-2 3.6zM17.2 2.1c1.2 0 2.2 1 2.2 2.2 0 1.2-1 2.2-2.2 2.2-1.2 0-2.2-1-2.2-2.2 0-1.3 1-2.2 2.2-2.2m0-2.1C14.9 0 13 1.9 13 4.3s1.9 4.3 4.3 4.3 4.3-1.9 4.3-4.3c-.1-2.4-2-4.3-4.4-4.3" clip-path="url(#SVGID_2_)" fill="#fff"/><path d="M8.9 16.3v5.2c-1.7-.3-2-1.8-2-2.2v-4.5-.2c.1-1.5 1-2.1 2-3.1l1.7-1.7c1.2-1.2 1.6-2.8 1.6-4.5C12.2 2.6 9.8.6 9.8.6S1.1 9.3.5 9.8c-.5.5-.5.9-.5 1.7v12.2c0 .5.1 1.1.7 1.8.6.8 5.9 6.7 6 8.9 0 .9-.3 1.9-.3 1.9h2.1s1-2.5-.4-4.5c-1.8-2.7-5-6.5-5.8-7.8-.3-.4-.3-.9-.3-1V11.6c0-.2.1-.4.2-.4l7.5-7.5c.3.5.5 1.3.5 1.7 0 .9-.3 2.1-1.1 2.9L7 10.5c-.9.8-1.7 1.4-2 2.5-.1.3-.1.6-.2 1v5.5c0 .1.1 1.2.8 2.2.4.5.9 1.1 1.7 1.5.4.2 1 .4 1.6.4h2v-7.4c0-1.8 1.9-3.5 3.3-3.8v24h2.2V9.5c-2.6 0-7.5 2.7-7.5 6.8M9.4 23.6h.5-1 .5zM25.5 16.3v5.2c1.7-.3 2-1.8 2-2.2v-4.5-.2c-.1-1.5-1-2.1-2-3.1l-1.7-1.7c-1.2-1.2-1.6-2.8-1.6-4.5 0-2.7 2.4-4.7 2.4-4.7l9.3 9.3c.5.5.5.9.5 1.7v12.2c0 .5-.1 1.1-.7 1.8-.6.8-5.9 6.7-6 8.9 0 .9.3 1.9.3 1.9h-2.1s-1-2.5.4-4.5c1.8-2.7 5-6.5 5.8-7.8.3-.4.3-.9.3-1V11.6c0-.2-.1-.4-.2-.4l-7.5-7.5c-.3.5-.5 1.3-.5 1.7 0 .9.3 2.1 1.1 2.9l2.1 2.2c.8.8 1.6 1.4 1.9 2.5.1.3.1.6.2 1v5.5c0 .1-.1 1.2-.8 2.2-.4.5-.9 1.1-1.7 1.5-.4.2-1 .4-1.6.4h-2v-7.4c0-1.8-1.9-3.5-3.3-3.8v24H18V9.5c2.6 0 7.5 2.7 7.5 6.8" clip-path="url(#SVGID_2_)" fill="#fff"/></svg>
                <span class="header__brand__sitename">Kirkens SOS</span>
                <span class="header__brand__slogan">
                  <span class="hide-for-small-only">Vi er her. alltid.</span>
                  <span class="show-for-small-only">Ring eller skriv.</span>
								</span>
              </a>
            </div>
            <nav class="small-6 medium-7 columns header__menu">
              <ul>
                <li class="header__menu__hamburger"><a href="#" data-toggle="offCanvas"><span>Meny</span></a></li>
                <li class="header__menu__search"><a href="https://www.kirkens-sos.no/sok"><span>Søk</span></a></li>
                <li class="header__menu__home"><a href="/"><span>Hjem</span></a></li>
                <li class="header__menu__facebook"><a href="https://www.facebook.com/Kirkens-SOS-149147255109855/" target="_blank"><span>Følg oss</span></a></li>
              </ul>
            </nav>
					</div>
					<div class="row collapse">
						<div class="small-12 large-11">
              <div class="header__statement">
                Trenger du noen å snakke med?
              </div>
						</div>
					</div>
					<div class="pictograms__container">
						<div class="row collapse pictograms__row">
							<a href="https://www.kirkens-sos.no/telefon" class="small-12 medium-4 columns pictogram pictogram-phone">
								<span class="pictogram__container">
									Ring
									<br> SOS
									<br> 22 40 00 40
								</span>
							</a>
							<a href="https://www.kirkens-sos.no/melding" class="small-6 medium-4 columns pictogram pictogram-message">
								<span class="pictogram__container">
									Skriv
									<br> SOS
									<br> Melding
								</span>
							</a>
							<a href="https://www.soschat.no" class="small-6 medium-4 columns pictogram pictogram-chat">
								<span class="pictogram__container">
									Skriv
									<br> SOS
									<br> Chat
								</span>
							</a>
						</div>
					</div>
				</header>
				<div class="container container-narrow pictograms__valign">
					<div class="row content__row">
						<router-view></router-view>
					</div>
				</div>
				<footer class="footer">
					<div class="row collapse">
						<div class="large-10 large-offset-1 column">
							<div class="footer__about">
								<p>Kirkens SOS i Norge ◦ Rådhusgata 1 ◦ 0151 Oslo ◦ <a href="mailto:post@kirkens-sos.no">post@kirkens-sos.no</a> ◦ <a>+47 23 08 13 80</a></p>
								<p>Illustrasjonsfoto: Torstein Ihle / portretter ansatte: Thomas Xavier Floyd / kampanjefoto: <a href="http://vonkommunikasjon.no/">Von kommunikasjon</a>/ Web: <a href="http://noop.no">Noop</a> / Design: <a href="http://www.ernooslo.no/" target="_blank">Ernö</a></p>
							</div>
						</div>
					</div>
				</footer>
      </div>

			<div class="off-canvas position-right menu__container is-transition-push" id="offCanvas" data-off-canvas="h79zs6-off-canvas" data-position="right" aria-hidden="true">
				<button class="menu__close" aria-label="Close menu" type="button" data-close="">
					<span aria-hidden="true">×</span>
				</button>
				<ul class="vertical menu">
					<li><a href="/">Hjem</a></li>
					<li><a href="https://www.kirkens-sos.no/om-kirkens-sos">Om Kirkens SOS </a>
					<ul>
					<li><a href="https://www.kirkens-sos.no/om-kirkens-sos/kontakt">Kontakt </a>
					</li></ul>
					</li>
					<li><a href="https://www.kirkens-sos.no/krisetjenesten">Tjenestene våre </a>
					<ul>
					<li><a href="https://www.kirkens-sos.no/krisetjenesten/skjule-besøkte-nettsider">Skjule besøkte nettsider </a>
					</li><li><a href="https://www.kirkens-sos.no/krisetjenesten/coockies-informasjonskapsler">Cookies </a>
					</li><li><a href="https://www.kirkens-sos.no/krisetjenesten/virker-ikke-sos-meldingen-på-din-maskin">Virker ikke SOS-meldingen? </a>
					</li><li><a href="https://www.kirkens-sos.no/krisetjenesten/tilbakemeldinger-på-sos-tjenestene">Gi oss tilbakemelding </a>
					</li></ul>
					</li>
					<li><a href="https://www.kirkens-sos.no/engasjer-deg">Engasjer deg </a>
					<ul>
					<li><a href="https://www.kirkens-sos.no/engasjer-deg/kontaktskjema">Kontaktskjema </a>
					</li><li><a href="https://www.kirkens-sos.no/engasjer-deg/om-innføringskurs-i-kirkens-sos">Kurs for nye frivillige </a>
					</li><li><a href="https://www.kirkens-sos.no/engasjer-deg/chat">Engasjertpåchat </a>
					</li><li><a href="https://www.kirkens-sos.no/engasjer-deg/telefon">Telefon </a>
					</li><li><a href="https://www.kirkens-sos.no/engasjer-deg/søknadskjema">Søknadskjema </a>
					</li></ul>
					</li>
					<li><a href="https://www.kirkens-sos.no/gi-en-gave">Gi en gave </a>
					<ul>
					<li><a href="https://www.kirkens-sos.no/gi-en-gave/gi-med-sms">Gi et engangsbeløp </a>
					</li><li><a href="https://www.kirkens-sos.no/gi-en-gave/fastgiver">Bli fastgiver </a>
					</li><li><a href="https://www.kirkens-sos.no/gi-en-gave/skattefradrag-for-givere">Skattefradrag for givere </a>
					</li><li><a href="https://www.kirkens-sos.no/gi-en-gave/givers-sikkerhet">Din trygghet som giver </a>
					</li></ul>
					</li>
					<li><a href="https://www.kirkens-sos.no/telefon">SOS-telefon </a>
					</li>
					<li><a href="https://www.kirkens-sos.no/chat">SOS-chat </a>
					</li>
					<li><a href="https://www.kirkens-sos.no/melding">SOS-Melding </a>
					<ul>
					</ul>
					</li>
					<li><a href="https://www.kirkens-sos.no/kanten">På Kanten </a>
					</li>
					<li><a href="https://www.kirkens-sos.no/giensamtale">Gi en samtale </a>
					</li>
					<li><a href="https://www.kirkens-sos.no/aktuelt">Aktuelt</a></li>					
					</ul>
				</div>
			</div>
	</div>
</template>

<script>
export default {
  name: 'App'
}
</script>
<style lang="scss">  
	@import './styles/global';
</style>


// WEBPACK FOOTER //
// src/App.vue